import CAApi from './_caApi';
import httpClient from '@/apis/base/httpclient';
class CAReceiptAPI extends CAApi {
  constructor() {
    super();
  }
  controllerName = 'CAReceipts';

  /**
   * Sinh dữ liệu sang chứng từ phiếu thu tiền mặt
   * TBNGOc 21.07.2022
   */
  getDataVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataVoucher',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu phiếu thu có liên quan rút dự toán
   * @param {*} idWithDraw
   * @returns
   * tbngoc 21.07.2022
   */
  getDataWithDrawRelation(idWithDraw) {
    let request = { url: [this.getAPIUrl(), `DataWithDraw?idWithDraw=${idWithDraw}`].join('/') };
    return httpClient.getAsync(request);
  }

  /**
   * lấy dữ liệu cho cho bảng nhập nội dung thanh toán khi vào form tham số lần đầu , mẫu 05TT
   * @param {*} refId
   * @returns
   */
  getDataForEnterPaymentContent(refId) {
    let request = { url: [this.getAPIUrl(), `GetDataForEnterPaymentContent?refId=${refId}`].join('/') };
    return httpClient.getAsync(request);
  }

  /**
   * Validate sinh dữ liệu đã ghi sôr
   * TBNGOc 21.07.2022
   */
  validateGenerateVoucherPosted(payload) {
    let request = {
      url: this.getAPIUrl() + '/ValidateGenerateVoucherPosted',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new CAReceiptAPI();
